import { render, staticRenderFns } from "./orderCustomer.vue?vue&type=template&id=b25b70e8&scoped=true&"
import script from "./orderCustomer.vue?vue&type=script&lang=js&"
export * from "./orderCustomer.vue?vue&type=script&lang=js&"
import style0 from "./orderCustomer.vue?vue&type=style&index=0&id=b25b70e8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b25b70e8",
  null
  
)

export default component.exports